const themes = [
  { name: 'Classic',      gradient: 'linear-gradient(to bottom, #3D8E5B, #1F5235)' },
  { name: 'Dark Mode',    gradient: 'linear-gradient(to bottom, #1A1F27, #0E1116)' },
  { name: 'Ocean Breeze', gradient: 'linear-gradient(to bottom, #3AA1D8, #0D4A72)' },
  { name: 'Forest Green', gradient: 'linear-gradient(to bottom, #5B9968, #1C3D2A)' },
  { name: 'Sunset Glow',  gradient: 'linear-gradient(to bottom, #FF8A5C, #7A2E3E)' },
  { name: 'Neon Lights',  gradient: 'linear-gradient(to bottom, #3A1860, #10081F)' },
  { name: 'Royal Purple', gradient: 'linear-gradient(to bottom, #6B3AA8, #3B1A6B)' },
];

export default themes;
